module.exports = __webpack_public_path__ + "static/media/bihac.ada3aca9.jpg";